import axios from 'axios';
import Cookies from 'js-cookie';

import {TENANT_BASE_URL, TOKEN_KEY, USER_NAME} from 'constants/Main';

import {removeCookie} from './cookies';

export const baseAxios = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 60000,
});

baseAxios.interceptors.request.use(config => {
  const token = Cookies.get(TOKEN_KEY);
  if(token){
    config.headers['Authorization'] = `Basic ${token}`;
  }
  return config;
},
error => {
  return Promise.reject(error);
});

baseAxios.interceptors.response.use(response => {
  if(response.status === 502){
    alert('error', 'Đã xảy ra lỗi, vui lòng thử lại sau');
  }
  return response;
},
error => {
  console.log(error);
  if(error.response?.status === 401) {
    removeCookie(USER_NAME);
  }
  return Promise.reject(error);
});

const baseUrl = localStorage.getItem(TENANT_BASE_URL) ? `${localStorage.getItem(TENANT_BASE_URL)}/api/` : 'https://api.nextcrm.vn/api/';

export const axiosInstance = axios.create({
  baseURL: baseUrl,
  timeout: 60000,
});

axiosInstance.interceptors.request.use(config => {
  const token = Cookies.get(TOKEN_KEY);
  if(token){
    config.headers['Authorization'] = `Basic ${token}`;
  }
  return config;
},
error => {
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use(response => {
  return response;
},
error => {
  if(error.response?.status === 401) {
    removeCookie(USER_NAME);
    // window.location = '/auth/login';
  }
  return Promise.reject(error);
});
